import React, { useState } from 'react';
import { Box, Skeleton } from '@mui/material';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import EditProjectList from './EditProjectList';
import EditTools from './EditTools';
import WatermarkCanvasContainer from './watermark/WatermarkCanvasContainer';
import CropCanvasContainer from './crop/CropCanvasContainer';
import MultiLangPlayer from '../common/MultiLangPlayer';

interface EditorContentProps {
    isLoading: boolean;
    setIsLoading: (loading: boolean) => void;
    setVideoDurationTime: (time: number) => void;
    videoDurationTime: number;
}

function EditorContent({ isLoading, setIsLoading, setVideoDurationTime, videoDurationTime }: EditorContentProps) {
    const { edit_id } = useParams();
    const projectInfo = useSelector((state: any) => state.editor.projectInfo);
    const [watermarkCanvasOpen, setWatermarkCanvasOpen] = useState(false);
    const [cropCanvasOpen, setCropCanvasOpen] = useState(false);
    const [changingList, setChangingList] = useState(false);
    return (
        <Box
            className='box-editor-content'
            style={{ height: edit_id && projectInfo.length > 0 ? 'calc(100% - 369.5px)' : 'calc(100% - 300px)' }}
        >
            <Box className="editor-tab__content-box">
                {isLoading ? (
                    <Box className="editor-tab__loading-container">
                        {[...Array(4)].map((_, idx) => (
                            <Box className="editor-tab__loading-row" key={idx}>
                                <Skeleton variant="rectangular" className="editor-tab__loading-skeleton-icon" />
                                <Skeleton variant="text" className="editor-tab__loading-skeleton-text" />
                            </Box>
                        ))}
                    </Box>
                ) : (
                    edit_id ? (
                        <EditTools
                            videoDurationTime={videoDurationTime}
                            setWatermarkCanvasOpen={setWatermarkCanvasOpen}
                            setCropCanvasOpen={setCropCanvasOpen}
                            setChangingList={setChangingList}
                        />
                    ) : (
                        <EditProjectList setIsLoading={setIsLoading} />
                    )
                )}
            </Box>
            <Box className="editor-tab__player-box container-editor-player">
                {watermarkCanvasOpen && <WatermarkCanvasContainer />}
                {cropCanvasOpen && <CropCanvasContainer />}
                <MultiLangPlayer setVideoDurationTime={setVideoDurationTime} />
            </Box>
        </Box>
    );
}

export default EditorContent; 